module.exports = __webpack_public_path__ + "img/ics_o_download_2.00c5f2ab.svg";